import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { fuseAnimations } from '@fuse/animations';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }],
  animations   : fuseAnimations
})


export class SurveyComponent implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  cambioSecciones:number=0;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog
  ) {
    this._fuseConfigService.config = {
        layout: {
            navbar   : {hidden: true},
            toolbar  : {hidden: false},
            footer   : {hidden: true},
            sidepanel: {hidden: true}
        }
    };
  }
  openDialog() {
      const dialogRef = this.dialog.open(DialogContentExampleDialog);

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    }
  openDialogDefiniciones(){
      const dialogRef = this.dialog.open(DialogContentExampleDialogDefiniciones);

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
  }

  toggleSidebar(name): void
  {
      this._fuseSidebarService.getSidebar(name).toggleOpen();
  }
  siguienteSeccion(){
    this.cambioSecciones++;
    console.log(this.cambioSecciones);


  }
  anteriorSeccion(){
    if(this.cambioSecciones>=1){
      this.cambioSecciones--;
      console.log(this.cambioSecciones);
    }


  }

}
@Component({
  selector: 'dialog-elements-example-dialog',
  templateUrl: 'dialog-elements-example-dialog.html',
})
export class DialogContentExampleDialog {}

@Component({
  selector: 'dialog-elements-example-dialog-definiciones',
  templateUrl: 'dialog-elements-example-dialog-definiciones.html',
})
export class DialogContentExampleDialogDefiniciones {}
